module.exports = __webpack_public_path__ + "media/images/athletes/1339-424dbef44c7e2f85fabca7e6f33b1987.png";